const SET_ARTICLES = 'SET_ARTICLES';
const ADD_ARTICLE = 'ADD_ARTICLE';
const UPDATE_ARTICLE = 'UPDATE_ARTICLE';
const REMOVE_ARTICLE = 'REMOVE_ARTICLE';

const Articles = {
	namespaced: true,
	state: {
		articles: [],
	},
	getters: {
		articles(state) {
			return state.articles;
		},
	},
	mutations: {
		[SET_ARTICLES](state, articles) {
			state.articles = articles;
		},
		[ADD_ARTICLE](state, article) {
			state.articles.unshift(article);
		},
		[UPDATE_ARTICLE](state, article) {
			if (state.articles.length > 0) {
				state.articles = state.articles.map((current) => {
					if (current.id === article.id) {
						return Object.assign({}, current, article);
					}
					return current;
				});
			}
		},
		[REMOVE_ARTICLE](state, article) {
			for (let i = 0; i < state.articles.length; i++) {
				const current = state.articles[i];
				if (current.id === article.id) {
					state.articles.splice(i, 1);
					break;
				}
			}
		},
		SOCKET_ARTICLES_ADD(state, article) {
			state.articles.unshift(article);
		},
		SOCKET_ARTICLES_UPDATE(state, article) {
			if (state.articles.length > 0) {
				state.articles = state.articles.map((current) => {
					if (current.id === article.id) {
						return Object.assign({}, current, article);
					}
					return current;
				});
			}
		},
		SOCKET_ARTICLES_DELETE(state, articleIds) {
			for (let i = 0; i < articleIds.length; i++) {
				const articleId = articleIds[i];
				for (let j = 0; j < state.articles.length; j++) {
					const current = state.articles[j];
					if (current.id === articleId) {
						state.articles.splice(j, 1);
						break;
					}
				}
			}
		},
	},
	actions: {
		saveArticles({ commit }, articles) {
			commit('SET_ARTICLES', articles);
		},
		addArticle({ commit }, article) {
			commit('ADD_ARTICLE', article);
		},
		removeArticle({ commit }, article) {
			commit('REMOVE_ARTICLE', article);
		},
		updateArticle({ commit }, article) {
			commit('UPDATE_ARTICLE', article);
		},
	},
};

export default Articles;
